<template>
  <b-nav-item @click="changeMode">
    <feather-icon
      size="21"
      :icon="`${isDark ? 'Sun' : 'Moon'}Icon`"
    /> 
  </b-nav-item>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'
import { BNavItem } from 'bootstrap-vue'

export default {
  components: {
    BNavItem,
  },
  setup() {
    const { skin } = useAppConfig()

    const isDark = computed(() => skin.value === 'dark')

    return { skin, isDark }
  },
  methods:{
    changeMode(){
      this.skin = this.isDark ? 'light' : 'dark';
      this.$store.commit('verticalMenu/CHANGE_LIGHT_MODE', this.skin)
    }
  }
}
</script>
